import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import theme from './theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LoadingSpinner from './components/LoadingSpinner';
import ScrollToTop from './components/ScrollToTop';
import lazyWithRetry from './components/LazyWithRetry';

// Lazy load components
const Home = lazyWithRetry(() => import('./components/Home'));
const Fleet = lazyWithRetry(() => import('./components/Fleet'));
const Services = lazyWithRetry(() => import('./components/Services'));
const Events = lazyWithRetry(() => import('./components/Events'));
const Corporate = lazyWithRetry(() => import('./components/Corporate'));
const Reservation = lazyWithRetry(() => import('./components/Reservation'));

// Lazy load service pages
const Conciergerie = lazyWithRetry(() => import('./components/services/Conciergerie'));
const Evenementiel = lazyWithRetry(() => import('./components/services/Evenementiel'));
const TransportAeroport = lazyWithRetry(() => import('./components/services/TransportAeroport'));
const Tourisme = lazyWithRetry(() => import('./components/services/Tourisme'));
const Mariage = lazyWithRetry(() => import('./components/services/Mariage'));

function App() {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6LeB-MkqAAAAAKLXRTzYcO-2ZqLyCF8DwqIgS2To"
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head'
      }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <ScrollToTop />
          <Box 
            sx={{ 
              minHeight: '100vh',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Navbar />
            <Box 
              component="main" 
              sx={{ 
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Suspense fallback={<LoadingSpinner />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/fleet" element={<Fleet />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/services/conciergerie" element={<Conciergerie />} />
                  <Route path="/services/evenementiel" element={<Evenementiel />} />
                  <Route path="/services/transport-aeroport" element={<TransportAeroport />} />
                  <Route path="/services/tourisme" element={<Tourisme />} />
                  <Route path="/services/mariage" element={<Mariage />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/corporate" element={<Corporate />} />
                  <Route path="/reservation" element={<Reservation />} />
                </Routes>
              </Suspense>
            </Box>
            <Footer />
          </Box>
        </Router>
      </ThemeProvider>
    </GoogleReCaptchaProvider>
  );
}

export default App;
